import axios from 'axios';

class BaseMitExternalApiService {
  constructor() {};

  getData(method, url, path, data) {
    return new Promise ((resolve, reject) => {
      if(url){
          //send to this apps back end which will forward it to the target endpoint
          let reqModel = {
            data:data, //this will get forwarded to the spaces api
            req:{
              method:method, //this will get forwarded to the spaces api
              path:path, //this will get forwarded to the spaces api
              url:url //The target service url
            }
          }
          axios.post('/api/v1/external/', reqModel)
            .then((response) => {
                return resolve(response.data);
            })
            .catch((error) => {
              console.log('ERROR:', error);
              return reject(error);
            });
      }
      else{
        //otherwise pass it back to this apps back end with no fancyness...
        method = method.toLowerCase();
        
        axios[method](path, data)
          .then((response) => {
            return resolve(response.data);
          })
          .catch((error) => {
            console.log('ERROR:', error);
            return reject(error);
          });
      }
      

    });
  }

}

export default BaseMitExternalApiService;
